module.exports = __webpack_public_path__ + "img/Skirt-Front-B8-Db-Fc-Hc-Ia.39ca3640.png";